module.exports = __webpack_public_path__ + "img/img26.a7cde8b6.png";